const base = { fill: "none", stroke: "currentColor", strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round" };

export function TeeIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 96 96" className={className} aria-hidden="true" {...base}>
      <path d="M30 18l10-6c3 5 13 5 16 0l10 6 14 14-12 10-4-4v38H32V38l-4 4-12-10z" />
      <path d="M38 58c6-8 10 4 15-4s7 6 12-2" stroke="#C25E38" strokeWidth={2.6} />
      <path d="M62 50l2 2" stroke="#C25E38" strokeWidth={2.6} />
    </svg>
  );
}

export function CapIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 96 96" className={className} aria-hidden="true" {...base}>
      <path d="M18 56c0-20 13-34 30-34s30 14 30 34" />
      <path d="M48 22c-7 6-10 20-10 34M48 22c7 6 10 20 10 34" strokeWidth={1.6} opacity=".7" />
      <path d="M18 56h60c6 0 12 3 12 7 0 6-14 9-28 7" />
      <path d="M18 56c-2 4-1 8 4 9" />
      <circle cx="48" cy="20" r="3" fill="currentColor" stroke="none" />
      <path d="M38 44c3 4 7 6 10 6s7-2 10-6" stroke="#C25E38" strokeWidth={2.6} />
      <path d="M40 36h.5M56 36h.5" stroke="#C25E38" strokeWidth={3.4} />
    </svg>
  );
}

export function NeedleIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 96 96" className={className} aria-hidden="true" {...base}>
      <path d="M22 74L70 26" strokeWidth={2.6} />
      <ellipse cx="73" cy="23" rx="4" ry="6" transform="rotate(45 73 23)" />
      <path d="M12 84c6-10 14-8 20-16s14-6 18-14" stroke="#C25E38" strokeWidth={2.6} />
      <path d="M30 40l4-10 10-4-10-4-4-10-4 10-10 4 10 4z" fill="#C25E38" stroke="none" opacity=".9" />
    </svg>
  );
}

export function SketchIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 96 96" className={className} aria-hidden="true" {...base}>
      <path d="M22 70l6-18 34-34 12 12-34 34z" />
      <path d="M56 24l12 12M28 52l12 12" />
      <path d="M18 78c10-6 18 4 28-2" stroke="#C25E38" strokeWidth={2.6} />
      <circle cx="76" cy="20" r="3" fill="#C25E38" stroke="none" />
    </svg>
  );
}
